import React, { ReactNode, useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { MobileStepper, Button, Box } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

type CarouselStep = {
  label: string | null;
  component: ReactNode;
};

export function Carousel({
  steps,
  padding,
}: {
  steps: CarouselStep[];
  padding?: number;
}) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [nextStepLabel, setNextStepLabel] = useState(steps[1]?.label);
  const [previousStepLabel, setPreviousStepLabel] = useState(
    steps[steps.length]?.label,
  );

  const maxSteps = steps.length;

  const handleNext = () => {
    const newStep = activeStep === steps.length - 1 ? 0 : activeStep + 1;
    setActiveStep(newStep);
  };

  const handleBack = () => {
    const prevStep = activeStep === 0 ? steps.length - 1 : activeStep - 1;
    setActiveStep(prevStep);
  };

  useEffect(() => {
    const nextStepLabel =
      activeStep === steps.length - 1
        ? steps[0]?.label
        : steps[activeStep + 1]?.label;
    const prevStepLabel =
      activeStep === 0
        ? steps[steps.length - 1]?.label
        : steps[activeStep - 1]?.label;
    setNextStepLabel(nextStepLabel);
    setPreviousStepLabel(prevStepLabel);
  }, [activeStep]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{ width: "100%", p: padding ?? 2 }}>
        {steps[activeStep]?.component}
      </Box>
      <MobileStepper
        variant="dots"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext}>
            {nextStepLabel}
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            {previousStepLabel}
          </Button>
        }
      />
    </Box>
  );
}
